var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { Fragment, useEffect, useMemo, useState } from 'react';
import { styled } from 'styled-components';
var ScTd = styled.td.withConfig({ displayName: "ScTd", componentId: "sc-quolcw" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  align-self: flex-start;\n  padding: 12px 0;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: left;\n"], ["\n  position: relative;\n  align-self: flex-start;\n  padding: 12px 0;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: left;\n"])));
function TableRow(_a) {
    var row = _a.row, rowIdx = _a.rowIdx, rowsLength = _a.rowsLength, columnsLength = _a.columnsLength, renderRowContent = _a.renderRowContent, getAdditionalRowProps = _a.getAdditionalRowProps, getAdditionalCellProps = _a.getAdditionalCellProps, renderSubRow = _a.renderSubRow, updateRow = _a.updateRow;
    var rowProps = useMemo(function () { return (__assign(__assign({}, row.getRowProps()), ((getAdditionalRowProps === null || getAdditionalRowProps === void 0 ? void 0 : getAdditionalRowProps(row)) || {}))); }, [getAdditionalRowProps, row]);
    var _b = useState(null), rowRef = _b[0], setRowRef = _b[1];
    useEffect(function () {
        if (rowRef) {
            var unsubscribe_1 = updateRow === null || updateRow === void 0 ? void 0 : updateRow(row, rowRef);
            return function () { return unsubscribe_1 === null || unsubscribe_1 === void 0 ? void 0 : unsubscribe_1(); };
        }
        return undefined;
    }, [row, rowRef, updateRow]);
    var rowContent = renderRowContent === null || renderRowContent === void 0 ? void 0 : renderRowContent(row);
    return (_jsxs(Fragment, { children: [_jsxs("tr", __assign({}, rowProps, { ref: function (ref) { return setRowRef(ref); } }, { children: [row.cells.map(function (cell) {
                        var cellProps = __assign(__assign({}, cell.getCellProps([
                            {
                                style: __assign(__assign({}, cell.column.style), { zIndex: cell.column.sticky ? rowsLength - rowIdx : undefined }),
                            },
                        ])), ((getAdditionalCellProps === null || getAdditionalCellProps === void 0 ? void 0 : getAdditionalCellProps(cell)) || {}));
                        return (_createElement(ScTd, __assign({}, cellProps, { key: cell.column.id }), cell.render('Cell', { rowIndex: rowIdx })));
                    }), rowContent && _jsx("td", { children: rowContent }, void 0)] }), void 0), row.isExpanded && renderSubRow && rowRef && (_jsx("tr", { children: _jsx(ScTd, __assign({ colSpan: columnsLength }, { children: renderSubRow(row, rowRef) }), void 0) }, void 0))] }, rowProps.key));
}
export { TableRow };
var templateObject_1;
